<template>
  <div class="benefit-tiles" :class="'benefit-tiles--' + variant">
    <component :is="clickable ? 'button' : 'div'" v-for="(item, i) in items" :key="i"
               :type="clickable ? 'button' : null" class="benefit-tile" :class="{clickable}"
               @click="clickable && $emit('select', item)">
      <span v-if="item.highlight" class="highlight">{{ item.highlight }}</span>
      <span v-else class="icon"><BenefitIcon :name="item.icon" :stroke="1.6" /></span>
      <span class="label" v-html="$t(item.label)"></span>
    </component>
  </div>
</template>

<script>
import BenefitIcon from "@/components/shared/BenefitIcon";

export default {
  name: "BenefitTiles",
  components: {BenefitIcon},
  props: {
    // [{ icon: 'nabytok', label: '...' }] alebo [{ highlight: '10/90', label: '...' }]
    items: {
      type: Array,
      required: true
    },
    // blue = hero panel na stránkach etáp, grey = sekcie na homepage
    variant: {
      type: String,
      default: 'blue'
    },
    clickable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px

.benefit-tiles
  display: flex
  gap: 8px

.benefit-tile
  width: 125px
  height: 100px
  padding: 10px 8px
  border: 0
  border-radius: 16px
  color: #fff
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  text-align: center

  @media (max-width: $md)
    flex: 1 1 0
    width: auto
    min-width: 0
    height: 88px
    padding: 8px 4px
    border-radius: 12px

  &.clickable
    cursor: pointer
    transition: filter 0.2s ease

    &:hover
      filter: brightness(1.06)

  .icon
    width: 60px
    height: 46px
    margin-bottom: 6px

    @media (max-width: $md)
      width: 40px
      height: 30px

  .highlight
    font-size: 26px
    line-height: 46px
    font-weight: bold
    margin-bottom: 6px

    @media (max-width: $md)
      font-size: 18px
      line-height: 30px

  .label
    font-size: 10.5px
    line-height: 1.25
    font-weight: 500

    @media (max-width: $md)
      font-size: 9px

.benefit-tiles--blue .benefit-tile
  background: var(--blue)
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2)

.benefit-tiles--grey .benefit-tile
  background: var(--grey)
  // v úzkom stĺpci textu sa dlaždice zmenšia namiesto pretečenia
  flex: 0 1 125px
  min-width: 0
</style>
